export default class Team {
  _id;
  _name;
  _divisions;
  _errorIndex = null;
  _assignedDivisions = 0;
  
  constructor(id, name, divisionKeys) {
    this._id = id;
    this._name = name;
    this._divisions = {};

    divisionKeys.forEach(key => {
      this._divisions[key] = null;
    });
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  setName(name) {
    this._name = name;
  }
  
  get divisions() {
    return JSON.parse(JSON.stringify(this._divisions));
  }

  get errorIndex() {
    return this._errorIndex;
  }

  get assignedDivisions() {
    return this._assignedDivisions;
  }

  setErrorIndex(index) {
    this._errorIndex = index;
  }

  assignUser(divisionKey, { id, fullName }) {
    if (!this._divisions[divisionKey]) {
      this._divisions[divisionKey] = { id, fullName };
      this._assignedDivisions++;
      return;
    }
    
    if (this._divisions[divisionKey] === null) {
      throw `Division ${divisionKey} has already assigned user!`;
    } else {
      throw `Team does not contain division ${divisionKey}!`;
    }
  }
  
  removeUser(divisionKey) {
    if (!!this._divisions[divisionKey]) {
      const removedUser = this._divisions[divisionKey];
      this._divisions[divisionKey] = null;
      this._assignedDivisions--;
  
      return removedUser;
    }
    
    if (this._divisions[divisionKey] === null) {
      throw `User has not been assigned to division ${divisionKey}!`;
    } else {
      throw `Team does not contain division ${divisionKey}!`;
    }
  }
}